import { Spinner } from "@fluentui/react-components";

export default function Loading() {
    return (
        <div className="center">
            <Spinner></Spinner>
        </div>
    );
}
